import axios from "axios";
import { audioCtx } from "@/lib/voce";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });

export const TENANT_KEY = "rh_tenant_token";
export const STAFF_KEY = "rh_staff_session";
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem(TENANT_KEY);
  if (t) cfg.headers["X-Tenant-Token"] = t;
  const s = localStorage.getItem(STAFF_KEY);
  if (s) cfg.headers["X-Staff-Token"] = s;
  return cfg;
});

export const eur = (n) =>
  new Intl.NumberFormat("it-IT", { style: "currency", currency: "EUR" }).format(Number(n || 0));

export const g = (url, params) => api.get(url, { params }).then((r) => r.data);
export const p = (url, body) => api.post(url, body).then((r) => r.data);
export const pu = (url, body) => api.put(url, body).then((r) => r.data);
export const pa = (url, body) => api.patch(url, body).then((r) => r.data);
export const del = (url) => api.delete(url).then((r) => r.data);

export const errMsg = (e) => {
  const d = e?.response?.data?.detail;
  if (e?.response?.data?.code === "solo_lettura") return "Vetrina: qui si guarda, non si tocca";
  if (typeof d === "string" && d.startsWith("suspended:")) return "Servizio sospeso: contatta Reprehendo";
  return d || "Operazione non riuscita";
};

// Vetrina: il server ferma le scritture, qui si apre il messaggio gentile con l'invito a provare.
api.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 403 && e.response.data?.code === "solo_lettura") {
      window.dispatchEvent(new CustomEvent("rh:solo-lettura"));
    }
    return Promise.reject(e);
  }
);

export const COURSES = [
  { id: 1, label: "1° Bevande e antipasti" },
  { id: 2, label: "2° Primi" },
  { id: 3, label: "3° Pizze" },
  { id: 4, label: "4° Secondi e contorni" },
  { id: 5, label: "5° Dolci e caffetteria" },
];

export const ITEM_STATES = {
  da_inviare: { label: "Da inviare", cls: "bg-slate-100 text-slate-600" },
  in_preparazione: { label: "In preparazione", cls: "bg-amber-100 text-amber-800" },
  pronto: { label: "Pronto", cls: "bg-emerald-100 text-emerald-800" },
  servito: { label: "Servito", cls: "bg-slate-900 text-white" },
};

export const beep = (double = true) => {
  try {
    // Un solo contesto condiviso, sbloccato al primo tocco: su iPhone un contesto nuovo
    // creato mentre arriva la notifica nasce sospeso e non si sente niente.
    const ctx = audioCtx();
    if (!ctx) return;
    const play = (t, freq) => {
      const o = ctx.createOscillator();
      const gain = ctx.createGain();
      o.frequency.value = freq;
      o.connect(gain);
      gain.connect(ctx.destination);
      gain.gain.setValueAtTime(0.0001, ctx.currentTime + t);
      gain.gain.exponentialRampToValueAtTime(0.25, ctx.currentTime + t + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + t + 0.13);
      o.start(ctx.currentTime + t);
      o.stop(ctx.currentTime + t + 0.14);
    };
    if (double) {
      play(0, 880);
      play(0.18, 880);
    } else {
      play(0, 220);
      play(0.2, 220);
      play(0.4, 220);
    }
  } catch (e) {
    console.warn("Audio non disponibile su questo dispositivo:", e?.message || e);
  }
};
